var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreLine = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#6D6D78"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.268 1C20.225 1 21 1.896 21 3c0 1.057-.71 1.922-1.609 1.996L19.268 5H2.732C1.775 5 1 4.104 1 3c0-1.056.709-1.922 1.609-1.994L2.732 1h16.536zM19.268 9C20.225 9 21 9.896 21 11c0 1.057-.71 1.922-1.609 1.996l-.123.004H2.732C1.775 13 1 12.104 1 11c0-1.057.709-1.922 1.609-1.994L2.732 9h16.536zM19.268 17c.957 0 1.732.896 1.732 2 0 1.057-.71 1.922-1.609 1.996l-.123.004H2.732C1.775 21 1 20.104 1 19c0-1.057.709-1.922 1.609-1.994L2.732 17h16.536z",
  transform: "translate(-320 -628) translate(0 611) translate(320 17)"
}))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreLine);
export default ForwardRef;